import React from 'react';
import './chapters.scss';
import Infographic from '../Infographic/Infographic';
import imageD from '../../assets/info1.jpg';
import imageM from '../../assets/info1-s.jpg';
function Chapter2() {
  const infographicData = {
    caption:
      'IHS, Gartner, ABI, Intel Analysis and KPMG Automotive Semiconductor Market Model, 2019',
    imageD: imageD,
    imageM: imageM,
    desc: "By 2035: 50% of a vehicle's electrical/electronic architecture will be consolidated using advanced chip technologies that enable years of updates. 76% of vehicles will be battery-powered and require 2x the semiconductors of a traditional vehicle. 100% of cars are expected to have some level of autonomy. The most advanced will require 9-10x more semiconductors",
    src: 'Sources'
  };
  return (
    <section className="chapters">
      <div className="chapters__copy">
        <h3>Semiconductors at the Center</h3>
        <p>
          This necessary technical transformation, posits Weast, “is fundamentally changing the
          modern vehicle from a mechanical device with embedded compute systems distributed around
          the car to a vehicle platform built around a high-performance computer with the
          traditional mechanical aspects of the vehicle taking a second seat."
        </p>
        <p>
          The traditional architecture of a vehicle—a fixed-function, distributed system—will need
          to give way to an architecture that is flexible, consolidated, connected, and
          software-defined. In practice, this means moving from over 100 ECUs, all connected by over
          a mile of copper cabling that can weigh as much as 150 pounds, to a software-defined
          vehicle with less than 50 ECUs. Instead of copper cabling, these ECUs will be connected
          with fiber, resulting in faster connections and more cost-effective manufacturing.
        </p>
      </div>
      <Infographic data={infographicData} />
    </section>
  );
}

export default Chapter2;
